const fields = [
    {name: 'delNomad', label: 'حذف عشایر'},
    {name: 'editNomad', label: 'ویرایش عشایر'},
    {name: 'addNomad', label: 'افزودن عشایر'},
    {name: 'delDriver', label: 'حذف راننده'},
    {name: 'editDriver', label: 'ویرایش راننده'},
    {name: 'addDriver', label: 'افزودن راننده'},
    {name: 'rejectReq', label: 'رد درخواست ها'},
    {name: 'manualDeliver', label: 'تایید تحویل دستی'},
    {name: 'addWaterReq', label: 'افزودن درخواست آب'},
    {name: 'getExcel', label: 'دریافت فایل اکسل'},
    {name: 'seeingReport', label: 'مشاهده گزارش گیری'},

    {name: 'delReq', label: 'حذف درخواست ها'},
            {name: 'editRequestTankerDays', label: 'ویرایش بازه زمانی ثبت درخواست'},

];

const CheckboxesComponent = ({handleChange, formik}) => {
    return(
        <div className='flex flex-wrap justify-between mb-5'>
            {fields.map((item, index) => {
                return(
                    <div className='w-[45%] sm:w-[33%] mb-1 text-[10px] sm:text-xs text-right' key={index}>
                        <label className='mr-1'>{item.label}</label>
                        <input type='checkbox' checked={formik.values.checked.includes(item.name)} name='checked' value={item.name} onChange={handleChange} />
                    </div>
                )
            })}

        </div>
    )
}

export default CheckboxesComponent